import { render } from "./LANDING_PAGE.vue?vue&type=template&id=8f6cf9be"
import script from "./LANDING_PAGE.vue?vue&type=script&lang=js"
export * from "./LANDING_PAGE.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Partheas\\Projects\\VDAB\\Code\\qpp-kiosk\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__